export const APPRAISAL_ORDER_CONTACTS_KEY = 'appraisalOrderContacts';

export const orderContactModifiedFieldsToExclude = ['id', 'loanAppraisalOrderContactId', 'loanId'];

export const AppraisalOrderContactKind = {
  BORROWER: 'Borrower',
  CO_BORROWER: 'CoBorrower',
  SELLERS_AGENT: 'SellersAgent',
  BUYERS_AGENT: 'BuyersAgent',
  OTHER: 'Other',
};

export const AppraisalOrderContactSource = {
  LOAN_DEFAULT: 'LoanDefault',
  BORROWER: 'Borrower',
  UNDERWRITING_AGENT: 'UnderwritingAgent',
  UNDERWRITING_SELLER: 'UnderwritingSeller',
  MANUAL: 'Manual',
  NONE: 'None',
};

export const ManualContactField = {
  FIRST_NAME: 'firstName',
  LAST_NAME: 'lastName',
  EMAIL: 'email',
  CELL_PHONE: 'cellPhone',
  HOME_PHONE: 'homePhone',
  WORK_PHONE: 'workPhone',
  PHONE: 'phone',
};

export const MANUAL_CONTACT_FIELDS = Object.values(ManualContactField);

export const MANUAL_CONTACT_PHONE_FIELDS = [
  ManualContactField.CELL_PHONE,
  ManualContactField.PHONE,
  ManualContactField.HOME_PHONE,
  ManualContactField.WORK_PHONE,
];

const AGENT_MANUAL_FIELDS = [
  ManualContactField.FIRST_NAME,
  ManualContactField.LAST_NAME,
  ManualContactField.EMAIL,
  ManualContactField.CELL_PHONE,
  ManualContactField.PHONE,
];

export const OrderContactSlot = {
  [AppraisalOrderContactKind.BORROWER]: {
    role: 'Borrower',
    isLocked: true,
    isAgentSlot: false,
    manualFields: [],
  },
  [AppraisalOrderContactKind.CO_BORROWER]: {
    role: 'Co-Borrower',
    isLocked: false,
    isAgentSlot: false,
    manualFields: [
      ManualContactField.FIRST_NAME,
      ManualContactField.LAST_NAME,
      ManualContactField.EMAIL,
      ManualContactField.CELL_PHONE,
      ManualContactField.HOME_PHONE,
      ManualContactField.WORK_PHONE,
    ],
  },
  [AppraisalOrderContactKind.SELLERS_AGENT]: {
    role: "Seller's Agent",
    isLocked: false,
    isAgentSlot: true,
    missingAgentType: 'listing',
    manualFields: AGENT_MANUAL_FIELDS,
  },
  [AppraisalOrderContactKind.BUYERS_AGENT]: {
    role: "Buyer's Agent",
    isLocked: false,
    isAgentSlot: true,
    missingAgentType: 'selling',
    manualFields: AGENT_MANUAL_FIELDS,
  },
  [AppraisalOrderContactKind.OTHER]: {
    role: 'Other',
    isLocked: false,
    isAgentSlot: false,
    manualFields: AGENT_MANUAL_FIELDS,
  },
};

export const ORDER_CONTACT_FIXED_KINDS = [
  AppraisalOrderContactKind.BORROWER,
  AppraisalOrderContactKind.CO_BORROWER,
  AppraisalOrderContactKind.SELLERS_AGENT,
  AppraisalOrderContactKind.BUYERS_AGENT,
];

export const ORDER_CONTACT_PINNED_SOURCES = [
  AppraisalOrderContactSource.BORROWER,
  AppraisalOrderContactSource.UNDERWRITING_AGENT,
  AppraisalOrderContactSource.UNDERWRITING_SELLER,
];

export const MAX_OTHER_ORDER_CONTACTS = 4;

export const OrderContactOptionGroup = {
  BORROWERS: 'Borrowers',
  LISTING_AGENTS: 'Listing agents',
  SELLING_AGENTS: 'Selling agents',
  SELLERS: 'Sellers',
  OTHER: 'Other',
};

export const OrderContactSourceLabel = {
  PRIMARY_BORROWER: 'Primary Borrower',
  CO_BORROWER: 'Co-Borrower',
  LISTING_AGENT: 'Listing Agent',
  SELLING_AGENT: 'Selling Agent',
  SELLER: 'Seller',
  SELLER_FOR_SALE_BY_OWNER: 'Seller · FSBO',
  MANUAL: 'Entered manually',
  ORDER_ONLY: 'Order only',
};

export const MANUAL_OPTION_VALUE = 'manual';

export const MANUAL_OPTION_LABEL = 'Enter contact manually';

export const UNSAVED_AGENT_HINT = 'Save the loan to use this agent';

export const NO_CONTACT_PLACEHOLDER = "Don't send";

export const ORDER_CONTACTS_TITLE = 'Order Contacts';

export const ORDER_CONTACTS_CAPTION =
  'Sent to Reggora when the appraisal is ordered. The primary contact is who the appraiser calls first to schedule the inspection.';

const OrderContactsColumnId = {
  PRIMARY: 'primary',
  ROLE: 'role',
  CONTACT: 'contact',
  EMAIL: 'email',
  PHONE: 'phone',
  ACTION: 'action',
};

export const ORDER_CONTACTS_COLUMNS = [
  { id: OrderContactsColumnId.PRIMARY, label: 'Primary', isCentered: true },
  { id: OrderContactsColumnId.ROLE, label: 'Role' },
  { id: OrderContactsColumnId.CONTACT, label: 'Contact' },
  { id: OrderContactsColumnId.EMAIL, label: 'Email' },
  { id: OrderContactsColumnId.PHONE, label: 'Phone' },
  { id: OrderContactsColumnId.ACTION, label: 'Action', isCentered: true, isEditOnly: true },
];

export const EMPTY_CELL_VALUE = '-';

export const MISSING_AGENT_NOTE_LINK_TEXT = 'Add one in Agent and Seller';

export const MISSING_AGENT_NOTE_SUFFIX = ' or enter a contact manually.';

export const RESET_BUTTON_TEXT = 'Reset to loan contacts';

export const ADD_CONTACT_BUTTON_TEXT = 'Add contact';

export const DESCRIPTION_PLACEHOLDER = 'Role';

export const PRIMARY_LABEL_TEXT = 'Primary';

export const OrderContactActionText = {
  SET_AS_PRIMARY: 'Set as primary',
  EDIT: 'Edit',
  OPEN_AGENT_AND_SELLER: 'Open in Agent and Seller',
  DONT_SEND: "Don't send",
  REMOVE: 'Remove',
};
